import React, { useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import { apolloClient } from '../Root';
import {
  OPTION_SWITCH_STATE,
  currentOptionToken,
  optionDetailPath,
} from 'HelperFunctions/optionGroups';
import LoadingSpinner from 'Utils/LoadingSpinner';

const GET_OPTION_GROUPS = gql`
  query GetStorefrontInventoryOptionGroups(
    $itemType: InventoryOptionGroupItemTypeEnum!
    $token: String!
  ) {
    getStorefrontInventoryOptionGroups(itemType: $itemType, token: $token) {
      id
      name
      options {
        descriptor
        itemType
        token
        slug
        current
      }
    }
  }
`;

// TD1-10685: one dropdown per option group the viewed item belongs to; picking a descriptor opens that sibling's page.
// Client-only: the query runs in useEffect, so SSR renders nothing here. `loading` is true while the page loads the
// option just picked: the dropdowns are disabled and a spinner shows until it arrives.
const OptionGroupSelects = ({ itemType, token, history, loading = false }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    if (!itemType || !token) return undefined;

    let cancelled = false;
    apolloClient
      .query({
        query: GET_OPTION_GROUPS,
        variables: { itemType, token },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        if (!cancelled)
          setGroups(data.getStorefrontInventoryOptionGroups || []);
      })
      .catch(() => {
        if (!cancelled) setGroups([]);
      });

    return () => {
      cancelled = true;
    };
  }, [itemType, token]);

  if (groups.length === 0) return null;

  const handleChange = (options) => (e) => {
    const option = options.find((o) => o.token === e.target.value);
    const path = option && optionDetailPath(option);
    if (path && !option.current) history.push(path, OPTION_SWITCH_STATE);
  };

  return (
    <div className='optionGroups' aria-busy={loading}>
      {groups.map((group) => (
        <label key={group.id} className='optionGroup'>
          <span>{group.name}</span>
          <select
            name={`optionGroup-${group.id}`}
            value={currentOptionToken(group.options)}
            onChange={handleChange(group.options)}
            disabled={loading}
          >
            {group.options.map((option) => (
              <option
                key={`${option.itemType}-${option.token}`}
                value={option.token}
              >
                {option.descriptor}
              </option>
            ))}
          </select>
        </label>
      ))}
      {loading && <LoadingSpinner />}
    </div>
  );
};

export default OptionGroupSelects;
